export interface APIToken {
  apiToken: string;
  sessionExpiry: number;
}

export enum AuthFlowType {
  password = 'password',
  samlRedirect = 'saml_redirect',
}

export interface IAuthState {
  username: string | null;
  password: string | null;
  showPasswordField: boolean;
  apiToken: APIToken | null;
  csfrToken: string | null;
  email: string;
  newPassword: string;
  verifyPassword: string;
  loading: boolean;
  error: string | null;
  remainingLoginAttempts?: number;
  updatePasswordSuccess?: boolean;
}
